//动态加载 组件
import { defineAsyncComponent } from "vue";
import path from 'path'
export default {
  install(app) {
    function camelToHyphen(str: string): string {
        return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    }
    // 遍历组态所有组件模块
        const components =import.meta.glob("./topo/control/*/*.vue")

        // 遍历组件模块实现自动注册
        for (const [key, value] of Object.entries(components)) {
            const name = key.match(/([^/]+)\.vue$/)?.[1];
            // 拼接组件注册的 name
           const componentName = camelToHyphen(name)

           // 通过 defineAsyncComponent 异步导入指定路径下的组件
           if(value){
              app.component(componentName, defineAsyncComponent(value))
           }
        }
  }
};
